import React, { Component } from "react";
import { Col, Row, Space, Button, Tooltip, Popover, Checkbox, } from "antd";
import { ReloadOutlined, PlusOutlined, SettingOutlined, } from "@ant-design/icons";

import "./TableListToolbar.less";
import ExportExcel from "./ExportExcel";

export default class TableListToolbar extends Component {

  state = {
    column: {
      values: [],
      options: [],
      allChecked: true,
    },
  };

  componentDidMount() {
    this.onAllChange(true);
  }

  getActionComp = (item) => {
    if (React.isValidElement(item)) {
      return item;
    }

    if (false !== item.visible) {
      switch (item.type) {
        case "create":
          return this.renderCreateAction(item);
        case "export":
          return this.renderExportAction(item);
        case "refresh":
          return this.renderRefreshAction(item);
        case "columnSet":
          return this.renderColumnSetAction(item);
        default:
          return typeof item.type === "undefined" ? null : this.renderDefaultAction(item);
      }
    }
  };

  renderCreateAction = (item) => {
    const { loading } = this.props;
    return (
      <Button
        type="primary"
        loading={loading}
        icon={<PlusOutlined />}
        onClick={item.onClick}
      >
        {item.title || "新增"}
      </Button>
    );
  };

  renderExportAction = (item) => {
    const { column } = this.state;
    return (
      <ExportExcel {...column} {...item} />
    );
  };

  renderRefreshAction = (item) => {
    const { loading } = this.props;
    return (
      <Tooltip
        title={item.title || "刷新"}
      >
        <Button
          type="link"
          loading={loading}
          icon={<ReloadOutlined />}
          onClick={item.onClick}
        />
      </Tooltip>
    );
  };

  renderDefaultAction = (item) => {
    return (
      <Button
        type="primary"
        icon={item.icon}
        onClick={item.onClick}
      >
        {item.title}
      </Button>
    );
  };

  renderColumnSetAction = () => {
    const { column, } = this.state;
    return (
      <Popover
        trigger="click"
        placement="bottomLeft"
        content={(
          <div className="nano-table-list-toolbar-column-set">
            <Checkbox
              checked={column.allChecked}
              onChange={this.onAllChange}
            >
              全部
            </Checkbox>
            <Checkbox.Group
              value={column.values}
              options={column.options}
              onChange={this.onItemChange}
            />
          </div>
        )}
      >
        <Tooltip title="展示列">
          <Button type="link" icon={<SettingOutlined />} />
        </Tooltip>
      </Popover>
    );
  };

  onAllChange = (e) => {
    const allChecked = typeof e === "boolean" ? e : e.target.checked;
    const columns = this.props.columns || [];
    const options = columns.map(v => ({
      label: v.title,
      value: v.dataIndex,
      dict: v.dict,
      fieldType: v.fieldType,
      format: v.format,
      exportWidth: v.exportWidth,
    }));
    this.setState({
      ...this.state,
      column: {
        ...this.state.column,
        options,
        allChecked,
        values: allChecked ? options.map(v => v.value) : [],
      },
    }, () => {
      this.onColumnChange();
    });
  };

  onItemChange = (values) => {
    values = values || [];
    const { column, } = this.state;
    this.setState({
      ...this.state,
      column: {
        ...column,
        values: [...values],
        allChecked: values.length === column.options.length,
      },
    }, () => {
      this.onColumnChange();
    });
  };

  onColumnChange = (values) => {
    if (this.props.onColumnChange) {
      values = values ? [...values] : [...this.state.column.values];
      this.props.onColumnChange([...values]);
    }
  };

  render() {
    const { headerTitle = "", actions = [] } = this.props;
    return (
      <div className="nano-table-list-toolbar">
        <Row className="nano-table-list-toolbar-container">
          <Col className="nano-table-list-toolbar-left" span={6}>
            <div className="nano-table-list-toolbar-title">
              {headerTitle}
            </div>
          </Col>
          <Col className="nano-table-list-toolbar-right" span={18}>
            <Space>
              {/* 限制10个按钮数量 */}
              {actions.length > 0 && this.getActionComp(actions[0])}
              {actions.length > 1 && this.getActionComp(actions[1])}
              {actions.length > 2 && this.getActionComp(actions[2])}
              {actions.length > 3 && this.getActionComp(actions[3])}
              {actions.length > 4 && this.getActionComp(actions[4])}
              {actions.length > 5 && this.getActionComp(actions[5])}
              {actions.length > 6 && this.getActionComp(actions[6])}
              {actions.length > 7 && this.getActionComp(actions[7])}
              {actions.length > 8 && this.getActionComp(actions[8])}
              {actions.length > 9 && this.getActionComp(actions[9])}
            </Space>
          </Col>
        </Row>
      </div>
    );
  };

};
